import React, { useState, useEffect } from 'react';
import { motion, AnimatePresence } from 'framer-motion';
import Icon from './AppIcon';
import { useTheme } from '../contexts/ThemeContext';

const ScrollUpButton = () => {
  const [isVisible, setIsVisible] = useState(false);
  const { isDark } = useTheme();

  useEffect(() => {
    const toggleVisibility = () => {
      if (window.pageYOffset > 300) {
        setIsVisible(true);
      } else {
        setIsVisible(false);
      }
    };

    window.addEventListener('scroll', toggleVisibility);
    return () => window.removeEventListener('scroll', toggleVisibility);
  }, []);

  const scrollToTop = () => {
    window.scrollTo({
      top: 0,
      behavior: 'smooth'
    });
  };

  return (
    <AnimatePresence>
      {isVisible && (
        <motion.button
          initial={{ opacity: 0, scale: 0.8, y: 20, rotateZ: -10 }}
          animate={{ opacity: 1, scale: 1, y: 0, rotateZ: 0 }}
          exit={{ opacity: 0, scale: 0.8, y: 20, rotateZ: 10 }}
          whileHover={{ scale: 1.1, rotateZ: 5, y: -4 }}
          whileTap={{ scale: 0.9 }}
          onClick={scrollToTop}
          className={`fixed bottom-4 left-4 sm:bottom-8 sm:left-8 z-50 w-16 h-16 rounded-xl shadow-2xl transition-all duration-300 hover:shadow-purple-500/50 ${
            isDark 
              ? 'bg-gradient-to-br from-purple-600 via-purple-700 to-blue-700 text-white' 
              : 'bg-gradient-to-br from-purple-500 via-purple-600 to-blue-600 text-white'
          } flex items-center justify-center group overflow-hidden cursor-pointer`}
          style={{
            boxShadow: '0 8px 32px rgba(147, 51, 234, 0.4), inset 0 -4px 8px rgba(0, 0, 0, 0.2), inset 0 4px 8px rgba(255, 255, 255, 0.1)'
          }}
          aria-label="Scroll to top"
        >
          {/* Animated gradient overlay */}
          <div className="absolute inset-0 bg-gradient-to-tr from-transparent via-white/20 to-transparent opacity-0 group-hover:opacity-100 transition-opacity duration-300 animate-shimmer"></div>
          
          {/* 3D border effect */}
          <div className="absolute inset-0 rounded-xl border-2 border-white/20"></div>
          <div className="absolute inset-1 rounded-lg border border-white/10"></div>
          
          <div className="relative z-10">
            <Icon 
              name="ChevronUp" 
              size={28} 
              className="transition-transform duration-300 group-hover:-translate-y-2 drop-shadow-lg"
              strokeWidth={2.5}
            />
          </div>

          {/* Tooltip */}
          <div className="absolute left-full ml-4 whitespace-nowrap bg-gradient-to-r from-gray-900 to-gray-800 text-white text-xs font-semibold px-4 py-2 rounded-lg opacity-0 group-hover:opacity-100 transition-all duration-300 pointer-events-none shadow-xl">
            Back to top
            <div className="absolute top-1/2 -left-1.5 transform -translate-y-1/2 w-3 h-3 bg-gray-900 rotate-45"></div>
          </div>

          {/* Corner accent */}
          <div className="absolute top-1 right-1 w-2 h-2 bg-white/30 rounded-sm"></div>
        </motion.button>
      )}
    </AnimatePresence>
  );
};

export default ScrollUpButton;